import { z } from 'zod';

export const feedbackSchema = z.object({
  type: z.enum(['Bug', 'Suggestion', 'General'], {
    message: 'feedback.validation.typeRequired',
  }),
  message: z
    .string()
    .min(1, 'feedback.validation.messageRequired')
    .max(5000, 'feedback.validation.messageTooLong'),
  missingFeature: z.string().max(5000, 'feedback.validation.messageTooLong').optional(),
  includeScreenshot: z.boolean(),
});

export type FeedbackFormData = z.infer<typeof feedbackSchema>;
